type GenufitDirectionCWordmarkProps = {
  className?: string
  variant?: 'auth' | 'sidebar'
}

/** Direction C wordmark — Genu/fit split colors; auth adds accent rule (HIR-198 v5). */
export function GenufitDirectionCWordmark({
  className,
  variant = 'auth',
}: GenufitDirectionCWordmarkProps) {
  if (variant === 'sidebar') {
    return (
      <div
        className={`flex min-w-0 items-center ${className ?? ''}`}
        data-testid="genufit-sidebar-wordmark"
      >
        <p className="m-0 whitespace-nowrap text-[15px] font-bold leading-none tracking-[-0.04em]">
          <span className="text-text-primary">Genu</span>
          <span className="text-brand-primary">Fit</span>
        </p>
      </div>
    )
  }

  return (
    <div className={`flex flex-col items-center ${className ?? ''}`}>
      <div className="inline-flex max-w-[160px] flex-col items-stretch sm:max-w-[200px]">
        <p className="m-0 whitespace-nowrap text-center text-[1.625rem] font-bold leading-none tracking-[-0.04em] sm:text-[2rem]">
          <span className="text-text-primary">Genu</span>
          <span className="text-brand-primary">Fit</span>
        </p>
        <span
          className="mt-[5px] h-[3px] rounded-sm bg-brand-primary opacity-35 sm:mt-1.5 sm:h-1"
          aria-hidden="true"
        />
      </div>
    </div>
  )
}
